<template>
  <div>
    <pillar-add></pillar-add>
  </div>
</template>

<script>
import PillarAdd from "./PillarAdd.vue";

export default {
  components: {
    PillarAdd,
  },

  data() {
    return {};
  },
};
</script>
